var exports = {
  "iE": "x24da60e8--795d68--wrapper",
  "Qq": "x24da60e8--795d68--text",
  "x6": "x24da60e8--795d68--button",
};

module.exports = exports;
